export default "__VITE_ASSET__douJGRAW__"